import React from 'react'
import * as R from 'ramda'

// Client-side pagination for the long admin queues.
//
// A render prop rather than a wrapper, so the caller keeps ownership of its own
// table markup — the curation passes each want different columns.
//
// The admin course table has its own older version of this (a factory returning
// { current, pages, render }). Migrating it to this one is worth doing, but as its
// own commit: it is working code on a different page, and a regression there
// should be bisectable on its own.
export default function Pagination({ items = [], page = 0, onPage, pageSize = 100, children }) {
  const pages = R.splitEvery(pageSize, items)
  const current = pages[page] || []

  return (
    <>
      {children(current)}

      {pages.length > 1 && (
        <div className="pagination-buttons mb-3">
          {pages.map((_, index) => (
            <button
              key={index}
              type="button"
              onClick={() => onPage(index)}
              className={`btn btn-sm btn-outline-${index === page ? 'success' : 'secondary'}`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
    </>
  )
}
